import { cn } from "@/lib/utils";
import React, { forwardRef } from "react";

export const Input = forwardRef(({ className, error, ...props }, ref) => {
  return (
    <div className="w-full">
      <input
        ref={ref}
        className={cn(
          "flex h-10 w-full rounded-md border border-bambu-green-light-3 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-bambu-green focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 font-montserrat",
          error && "border-bambu-red focus:ring-bambu-red",
          className
        )}
        {...props}
      />
      {error && (
        <p className="mt-1 text-xs text-bambu-red">{error}</p>
      )}
    </div>
  );
});

Input.displayName = "Input";
